import {
  Box,
  Button,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

export const SearchFilterBar = ({
  searchType,
  handleSearchTypeChange,
  handleSearch = (f) => f,
  handleSearchInputChange = (f) => f,
  handleSearchInputBlur = (f) => f,
  searchTypes,
  searchValue,
}) => {
  const currentType = searchTypes.find((t) => t.value === searchType);
  const placeholder = currentType?.placeholder || "Enter search query";
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        marginBottom: 4,
      }}
    >
      <SearchTypeSelector
        searchType={searchType}
        handleSearchTypeChange={handleSearchTypeChange}
        searchTypes={searchTypes}
      />
      <Box
        sx={{
          display: "flex",
          gap: 1,
        }}
      >
        <TextField
          fullWidth
          size="small"
          placeholder={placeholder}
          value={searchValue}
          onChange={handleSearchInputChange}
          onBlur={handleSearchInputBlur}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />

        <Button
          variant="contained"
          sx={{
            px: 5,
            fontWeight: 500,
          }}
          onClick={handleSearch}
        >
          Search
        </Button>
      </Box>
      <DecorateListTypes searchTypes={searchTypes} />
    </Box>
  );
};

export const DecorateListTypes = ({ searchTypes }) => {
  return (
    <Typography variant="caption" color="text.secondary">
      Search by {searchTypes.map((t) => t.label.toLowerCase()).join(", ")}.
    </Typography>
  );
};

export const SearchTypeSelector = ({
  searchType,
  handleSearchTypeChange,
  searchTypes,
}) => {
  return (
    <FormControl size="small" sx={{ minWidth: 130 }}>
      <Select value={searchType} onChange={handleSearchTypeChange}>
        {searchTypes.map((type) => (
          <MenuItem key={type.value} value={type.value}>
            {type.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
